'use strict';

var React = require('react');

var cleanElement = function cleanElement(Component) {
  var Cleaned = function Cleaned(props) {
    var next = {};
    var keys = Object.keys(Cleaned.propTypes || {});
    for (var key in props) {
      if (keys.includes(key)) continue;
      next[key] = props[key];
    }

    return React.createElement(Component, next);
  };

  return Cleaned;
};

module.exports = cleanElement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-system/dist/clean-element.js
// module id = 127
// module chunks = 0